export const environment = {
  BASE_API_URL: 'https://staging.optcentral.app/api',
  RACAPTCHA_SITE_KEY: '6LcbZB8rAAAAAP0zAHQaxwdKJT9hFbDhkEhyDcoe',
  USE_RECAPTCHA: false,
  FIREBASE_DETAILS: {
    apiKey: 'AIzaSyB5MANLh-45SBVBt6uCxLt-WRJd_b4dJ7Q',
    authDomain: 'opt-central.firebaseapp.com',
    projectId: 'opt-central',
    storageBucket: 'opt-central.firebasestorage.app',
    messagingSenderId: '422960090144',
    appId: '1:422960090144:web:33417f70ecf2fb16b7c045',
    measurementId: 'G-FRCMCWXCXV',
  },
  SHOW_STAGING_BANNER: true,
};
